// extracted by mini-css-extract-plugin
module.exports = {"switch":"SliderButton_switch__2HBVY","slider":"SliderButton_slider__29YzF","slider-container":"SliderButton_slider-container__2eOqO"};